import { endorsements } from '../../../copy/endorsements';
import EndorsementCard from './EndorsementCard';
import {
  MainContainer,
  HeaderContainer,
  MainHeading,
  LinkedInButton,
  EndorsementsStack,
} from './Endorsements.styles';

function Endorsements() {
  return (
    <MainContainer>
      <HeaderContainer direction="row">
        <MainHeading variant="h2" component="h2">
          Those who know me say...
        </MainHeading>
        <LinkedInButton
          target="_blank"
          rel="noopener"
          variant="text"
          href="https://www.linkedin.com/in/hadleyswello/details/recommendations/"
        >
          View These on LinkedIn
        </LinkedInButton>
      </HeaderContainer>
      <EndorsementsStack>
        {endorsements.map(endorsement => {
          return (
            <EndorsementCard
              key={endorsement.reviewer}
              endorsement={endorsement}
            />
          );
        })}
      </EndorsementsStack>
    </MainContainer>
  );
}

export default Endorsements;
